export const ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER = 'ArchivePolicyParentRow';
export const DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER = 'DeletePolicyParentRow';
export const ARCHIVE_TAG_FIELD_URI = 'FolderArchiveTag';
export const DELETE_TAG_FIELD_URI = 'FolderPolicyTag';
